import type { SelectedFile } from '@witmetrics/utils';
import type { CreationStep, CreationStepStatus } from '../types';
import { CREATION_STEP, CREATION_STEP_STATUS } from '../constants';

const { CREATE_PROJECT } = CREATION_STEP;
const { PENDING, IN_PROGRESS, DONE } = CREATION_STEP_STATUS;

export const classes = {
  dialog: 'w-[95vw] max-w-[500px] min-w-[300px] flex flex-col',
  dialogTitle: 'mb-0 pb-2',
  body: 'grow pt-0 pb-4 min-h-0 w-full',
  card: 'w-full py-3 px-3 gap-4 shadow-none border border-grey-3 dark:border-white/10 place-start my-3 text-base text-grey-8 dark:text-mauve-1 transition-opacity',
  pending: 'opacity-50',
};

export function getProjectStatus(step: CreationStep) {
  return step === CREATE_PROJECT ? IN_PROGRESS : DONE;
}

export function getFileStatus(step: CreationStep, file: SelectedFile) {
  if (step === CREATE_PROJECT) return PENDING;
  if (file.uploadStatus === IN_PROGRESS) return IN_PROGRESS;
  if (file.uploadStatus === DONE) return DONE;
  return PENDING; // Default in case the file is some other status
}

export function getServiceStatus(step: CreationStep) {
  if (step === CREATION_STEP.INITIALIZE_SERVICE) return IN_PROGRESS;
  return PENDING;
}

export function getSubmissionStatus(
  uuid: string,
  submissionStatuses: Record<string, CreationStepStatus>
): CreationStepStatus {
  return submissionStatuses[uuid] || PENDING;
}

export function getTaskStatus(
  uuid: string,
  taskStatuses: Record<string, CreationStepStatus>
): CreationStepStatus {
  return taskStatuses[uuid] || PENDING;
}
